module.exports = __webpack_public_path__ + "img/splash.fca2ed36.svg";